import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { CgMail } from "react-icons/cg";
import { IoIosCall } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import ProductsData from "./dataFiles/ProductData";

const DetailPage = () => {
  const [data, setData] = useState([]);
  const [contactIds, setContactIds] = useState([]);
  const [loader, setLoader] = useState(true);
  const [filterProduct, setFilterProduct] = useState([]);
  const [similarProducts, setSimilarProducts] = useState([]);
  const [button, setButton] = useState(true);

  const navigate = useNavigate();
  const { id } = useParams();

  const getApi = () => {
    setLoader(true);
    axios
      .get("https://bestdealelectricalsbackend.onrender.com/bestdealelectricals/products")
      .then((res) => {
        const products = res.data.Products;
        setData(products);
        setFilterProduct(products.filter((item) => item._id === id));
        setSimilarProducts(products.filter((item) => item._id !== id));
        setLoader(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        const fallback = ProductsData;
        setData(fallback);
        setFilterProduct(fallback.filter((item) => item._id === id));
        setSimilarProducts(fallback.filter((item) => item._id !== id));
        setLoader(false);
      });
  };

  useEffect(() => {
    setLoader(true);
    setButton(true);
    setContactIds([]);
    getApi();
  }, [id]);

  const ChangePage = (newId) => {
    if (newId !== id) {
      navigate(`/detailPage/${newId}`);
      window.scrollTo(0, 0);
    }
  };

  const ActiveContact = (id) => {
    setContactIds((prev) => [...prev, id]);
  };

  const DeactiveContact = (id) => {
    setContactIds((prev) => prev.filter((itemId) => itemId !== id));
  };

  const handleContact = () => {
    setButton(!button);
  };

  return (
    <section className="py-5">
      <div className="container">
        {loader ? (
          <div className="loader"></div>
        ) : (
          <>
            <div className="row">
              {filterProduct?.map((item) => (
                <div key={item._id} className="row mb-5">
                  <div className="col-md-6 d-flex justify-content-center align-items-center">
                    <img src={item.image} className="w-100" alt={item.title} />
                  </div>
                  <div className="col-md-6 d-flex align-items-center">
                    <div className="p-3">
                      <h3 className="fw-bold mb-3">{item.title}</h3>
                      <p><strong>Brand:</strong> {item.brand}</p>
                      <p><strong>Description:</strong> {item.description}</p>
                      <div className="mt-2">
                        <strong>Features:</strong>
                        <ul className="features-list mt-2">
                          {item.features
                            .split("-")
                            .filter((f) => f.trim() !== "")
                            .map((feature, index) => (
                              <li key={index}>{feature.trim()}</li>
                            ))}
                        </ul>
                      </div>
                      {button ? (
                        <button className="button mt-3 py-1 px-3" onClick={handleContact}>Contact</button>
                      ) : (
                        <div className="d-flex justify-content-left p-3 contact-container">
                          <div className="cross" onClick={handleContact}>
                            <RxCross2 className="h3" />
                          </div>
                          <ul className="d-flex icons-ul gap-3 justify-content-center align-items-center">
                            <a href="tel:+919779096815" target="_blank" rel="noopener noreferrer">
                              <li className="call"><IoIosCall /></li>
                            </a>
                            <a href="mailto:bestdealelectricals4444@gmail.com" target="_blank" rel="noopener noreferrer">
                              <li className="mail"><CgMail /></li>
                            </a>
                            <a href="https://wa.me/919779096815" target="_blank" rel="noopener noreferrer">
                              <li className="whatsapp"><FaWhatsapp /></li>
                            </a>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="position-relative heading-container mx-auto mb-4">
              <h2 className="heading">
                S<span className="heading-span">IMILAR</span> P<span className="heading-span">RODUCTS</span>
              </h2>
              <div className="line"></div>
            </div>

            <div className="row">
              {similarProducts?.map((items) => (
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 p-3" key={items._id}>
                  <div className="products-container h-100 d-flex flex-column">
                    <div className="image-container" onClick={() => ChangePage(items._id)}>
                      <img src={items.image} className="w-100 products-img rounded-top" alt={items.title} />
                    </div>
                    {contactIds.includes(items._id) ? (
                      <div className="p-3 contact-container contact-icon">
                        <div className="cross" onClick={() => DeactiveContact(items._id)}>
                          <RxCross2 className="h3" />
                        </div>
                        <ul className="d-flex icons-ul gap-3 justify-content-center align-items-center">
                          <a href="tel:+919779096815" target="_blank" rel="noopener noreferrer">
                            <li className="call"><IoIosCall /></li>
                          </a>
                          <a href="mailto:bestdealelectricals4444@gmail.com" target="_blank" rel="noopener noreferrer">
                            <li className="mail"><CgMail /></li>
                          </a>
                          <a href="https://wa.me/919779096815" target="_blank" rel="noopener noreferrer">
                            <li className="whatsapp"><FaWhatsapp /></li>
                          </a>
                        </ul>
                      </div>
                    ) : (
                      <div className="p-3">
                        <div className="title fw-bold mb-2">
                          {items.title?.length > 25 ? `${items.title.slice(0, 25)}...` : items.title}
                        </div>
                        <div className="title" id="brand">
                          Brand: <span className="brand fw-normal">{items.brand}</span>
                        </div>
                        <div className="mt-3 d-flex justify-content-left">
                          <button className="button py-1 px-3" onClick={() => ActiveContact(items._id)}>
                            Contact
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default DetailPage;
